import { createAppStore } from '@app/core/stores';
import { getQueryParam } from '@mi-front/core';
import { createJSONStorage } from 'zustand/middleware';

interface ToursState {
  /** Map of tour keys to seen status (true if seen). */
  seenTours: Record<string, boolean>;

  /** Marks a tour as seen. */
  markTourAsSeen: (key: string) => void;

  /** Checks if a tour has been seen. */
  hasSeenTour: (key: string) => boolean;

  /** Clears all seen tours. */
  resetAllTours: () => void;

  /**
   * Checks if URL has "tours_reset" query param.
   * If so, resets all tours. Does not modify the URL.
   */
  checkUrlActions: () => void;
}

export const useToursStore = createAppStore<ToursState>('ToursStore', {
  persist: {
    name: 'feature-tours-storage',
    storage: createJSONStorage(() => localStorage),
    purgeOnLogout: false,
  },
})((set, get) => ({
  seenTours: {},

  markTourAsSeen: (key) => {
    set((state) => ({
      seenTours: { ...state.seenTours, [key]: true },
    }));
  },

  hasSeenTour: (key) => {
    return !!get().seenTours[key];
  },

  resetAllTours: () => {
    set({ seenTours: {} });
  },

  checkUrlActions: () => {
    if (typeof window === 'undefined') return;

    if (getQueryParam('tours_reset')) {
      get().resetAllTours();
    }
  },
}));
